// @flow

export default {
	WHO: 12,
	CONDITION: 13,
	ACTION: 14,
	CREATOR: 15,
	OrderRuleFilterType: 12 | 13 | 14 | 15,
}
